// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/realisations'

// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// OwlCarousel
async function getOwlCarousel () {
  import(/* webpackChunkName: "owl-carousel" */ './js/components/owl-carousel.js').then(() => {
    r()
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "custom-lists" */ './js/components/custom-lists.js').then(() => {
    r()
  })
}

// MasterSlider
async function getMasterSlider () {
  import(/* webpackChunkName: "master-slider" */ './js/components/master-slider.js').then(() => {
    r()
  })
}

// Pajination
async function getPajination () {
  import(/* webpackChunkName: "pajination" */ './js/components/pajination.js').then(() => {
    r()
    // sur changement de page, on se repositionne sur le début de listing
    $('ul.pagination > li > a').on('click', function () {
      $('html,body').animate({ scrollTop: $('#realisations').offset().top - 100 }, 300)
      r()
    })
  })
}

// Contact Form
async function getContactForm ($f) {
  import(/* webpackChunkName: "contact-form" */ './js/components/contact-form.js').then(() => {
    $f.load(false)
    r()
  })
}

// Agency autocomplete
async function getAgencyAutocomplete ($f) {
  import(/* webpackChunkName: "quick-agency-search-form" */ './js/components/quick-agency-search-form.js').then(module => {
    const form = module.qasForm
    form.init($f)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion des carousel
  const $d = $('.owl-carousel.c')
  if ($d.length) {
    $d.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des scrollbars améliorées
  const $c = $('.custom-lists')
  if ($c.length) {
    $c.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion master slider
  const $m = $('#masterslider')
  if ($m.length) {
    $m.waypoint(function () {
      getMasterSlider()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des pages
  const $p = $('.pajinate')
  if ($p.length) {
    $p.waypoint(function () {
      getPajination()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      $f.load()
      getContactForm($f)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // formulaire de sélection d'une région ou d'un département à recharger en URL
  $('form[name="location-form"] select[name="region"]').on('change', function () {
    $(this).parents('form').attr('action', $(this).parents('form').attr('action') + '/' + $(this).val()).submit()
  })
  $('form[name="location-form"] select[name="department"]').on('change', function () {
    $(this).parents('form').attr('action', $(this).parents('form').attr('action') + '/' + $(this).val()).submit()
  })

  // filtres des agences autocomplete
  $('form[name="qasForm"] input[name="search"]').on('click', function () {
    $(this).blur().off('click').attr('disabled', '')
    getAgencyAutocomplete($(this).parents('form'))
  })

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    r()
  })
})
